import { useTranslation } from "react-i18next";
import type { AnalyticsSnapshotResponse } from "@/features/admin/adminAnalytics.types";
import { GenericAnalyticsTab } from "@/features/admin/components/analytics/GenericAnalyticsTab";

export function RevenueSubscriptionsAnalyticsTab({ loading, snapshot }: { loading?: boolean; snapshot: AnalyticsSnapshotResponse | null }) {
  const { t } = useTranslation();
  return (
    <GenericAnalyticsTab
      loading={loading}
      panels={[
        { chart: "line", metricKey: "mrr_cents", series: ["total"], title: t("adminWorkspace.analytics.revenue.mrrTrend") },
        { chart: "bar", metricKey: "subscription_events_by_type", series: ["customer.subscription.created", "customer.subscription.updated", "customer.subscription.deleted"], title: t("adminWorkspace.analytics.revenue.subscriptionEvents") },
      ]}
      snapshot={snapshot}
    />
  );
}
